import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from "react";
import DATEPICKER_OR from  "../../../../../common/custom-form/custom-date-picker.component";
import Translation from "../../../../../common/translation/translation.component";
import store from "../../../../../../store";
import { actions } from 'react-redux-form';
import { orderMilestoneAction } from '../../../../../../store/external/order/milestone/order-milestone.reducer'
import { REQUEST_TYPES, REQUEST_TYPE_MILESTONE, CIRCUIT_STATUS, QUOTATION_CODE_DETAIL } from '../../../../../../constants/external-constants';
import {
    SelectFieldFloatingLabel as Select
} from "../../../../../common/custom-form/select-filter.component";
import { circuitOrderActions } from '../../../../../../store/external/order/order-circuit.reducer';
import { sideNavMenuActions } from '../../../../../../store/external/side-nav-menu-reducer/side-nav-menu.reducer';
import { addPlanDetailActions } from '../../../../../../store/external/inventory/details-view/add-plan-details.reducer';
import { inventoryCircuitSimActions } from '../../../../../../store/external/inventory/details-view/add-sim.reducer';
import { inventoryCircuitEquipActions } from '../../../../../../store/external/reports-reducer/inventory/details-view/add-equipment.reducer';
import { inventoryCostAllocationActions } from '../../../../../../store/external/inventory/add-cost-allocation.reducer';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';

class CircuitInstallMilestone extends Component {
    constructor(props) {
        super(props);
        this.state={
            disconnectDate:null,
            orderCloseDate:null
        }
    }

    handleDisconnectDate=(date)=>{
        store.dispatch(actions.change('orderMilestoneForm.installOrdisconnectDate',date))
    }

    handleOrderCloseDate=(date)=>{
        store.dispatch(actions.change('orderMilestoneForm.orderClosedDate',date))
    }

    async componentDidMount() {
        const { orderMilestoneForm, getMilestoneCircuitStatusesDropdown } = this.props;
        this.setState({
            confirmationDate: orderMilestoneForm.installOrdisconnectDate,
            commitmentDeliveryDate: orderMilestoneForm.orderClosedDate,
        })
        await getMilestoneCircuitStatusesDropdown();
    }

    componentWillUnmount = () => {
        const { orderMilestoneForm, disableFields } = this.props;

        if(!disableFields){
            const fieldsToClear = [
                { current: this.state.disconnectDate, saved: orderMilestoneForm.installOrdisconnectDate, action: this.handleDisconnectDate },
                { current: this.state.orderCloseDate, saved: orderMilestoneForm.orderClosedDate, action: this.handleOrderCloseDate },
            ];

            fieldsToClear.forEach(({ current, saved, action }) => {
                if (current != saved && typeof action === 'function') {
                    action(null);
                }
            });
        }
    };
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (!locale || !translation[locale]) {
            return translation[translation['defaultLocaleLanguage']][key];
        }

        return translation[locale][key];
    }

    render() {
        const { installOrdisconnectDate, orderClosedDate, orderType } = this.props.orderMilestoneForm
        const { disableFields, circuitOrderForm, requestType, orderMilestoneDetails } = this.props
        const orderTypeField = orderType === REQUEST_TYPE_MILESTONE.simple ? "install_date" : 
            orderType === REQUEST_TYPE_MILESTONE.change ? "change_order_date" : "disconnect_date";
        const showCircuitStatus = requestType === REQUEST_TYPES.suspendResumeService;
        return(
            <div className={`order-milestone__form message-form-body ${this.props.customClass}`} > 
                 { requestType !== REQUEST_TYPES.newQuotation
                    && requestType !== QUOTATION_CODE_DETAIL.newQuotation 
                    && requestType !== QUOTATION_CODE_DETAIL.upgradeQuotation ?
                     <DATEPICKER_OR
                     dateOnly={true}
                     label={<Translation translationKey={`${orderTypeField}`} />}
                     startDate={installOrdisconnectDate}
                     selectedDate={(date) => this.handleDisconnectDate(date)}
                     requiredField={true}
                     isDisable={disableFields}
                    />  : null
                    }               
               

                    <DATEPICKER_OR
                    dateOnly={true}
                    label={<Translation translationKey={'order_close_date'} />}
                    startDate={orderClosedDate}
                    selectedDate={(date) =>this.handleOrderCloseDate(date)}  
                    requiredField={true}     
                    isDisable={disableFields}
                />
                {showCircuitStatus && (
                    <Select
                        className="form-select required"
                        label={<Translation translationKey={'circuit_status'} />}
                        value={circuitOrderForm.circuitOrderDetails?.statusID || CIRCUIT_STATUS.suspended.id} // Default to 3 if statusID is not defined
                        options={orderMilestoneDetails.milestoneCircuitStatusDropdown}
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='circuitOrderForm.circuitOrderDetails.statusID'
                        disabled={disableFields}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => {
        const { orderMilestoneDetails,
            form: { forms: { orderMilestoneForm: { $form } } },
        } = state;
        const { orderMilestoneForm, circuitOrderForm } = state.form;
        const { circuitOrder, inventoryCircuitPlanDetails, inventoryCircuitSIM, inventoryCircuitEquip, inventoryCostAllocation } = state;
        const { circuitOrderInventoryCircuitPlanDetails, circuitOrderInventoryCircuitSIM, circuitOrderInventoryCircuitEquip, circuitOrderInventoryCostAllocation } = state;
        
        return {
            
            orderMilestoneForm
            ,orderMilestoneDetails
            ,$form
            ,circuitOrder
            , circuitOrderForm
            , inventoryCircuitPlanDetails
            , inventoryCircuitSIM
            , inventoryCircuitEquip
            , inventoryCostAllocation
            , circuitOrderInventoryCircuitPlanDetails
            , circuitOrderInventoryCircuitSIM
            , circuitOrderInventoryCircuitEquip
            , circuitOrderInventoryCostAllocation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderMilestoneAction
                , circuitOrderActions
                , sideNavMenuActions
                , addPlanDetailActions
                , inventoryCircuitSimActions
                , inventoryCircuitEquipActions
                , inventoryCostAllocationActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(CircuitInstallMilestone);